<template>
<div>
  <v-row>
    <v-col cols="12" sm="12">
      <v-text-field label="* Nome"
                dense
                :rules="[
                  this.$validators.string.required,
                  v => this.$validators.string.greaterThanOrEquals(v, 1),
                  v => this.$validators.string.lessThanOrEquals(v, 100),
                ]"
                v-model.trim="value.nome"/>
    </v-col>
    <!-- ----------------------------------------------------  -->
    <v-col cols="12" sm="6">
      <v-text-field label="* Email"
                    dense
                    :rules="[
                      this.$validators.string.required,
                      this.$validators.string.email,
                      v => this.$validators.string.lessThanOrEquals(v, 50),
                    ]"
                    v-model.trim="value.email"/>
    </v-col>
    <v-col cols="12" sm="3">
      <v-text-field label="* Cargo"
                dense
                :rules="[
                  this.$validators.string.required,
                  v => this.$validators.string.greaterThanOrEquals(v, 1),
                  v => this.$validators.string.lessThanOrEquals(v, 100),
                ]"
                v-model.trim="value.cargo"/>
    </v-col>
    <v-col cols="12" sm="3">
      <v-text-field v-if="empresaEstrangeira"
                    :label="labelCpfResponsavel"
                    dense
                    placeholder="Registro do responsável"
                    :rules="rulesCpfResponsavel"
                    v-model.trim="value.cpf"/>
      <v-text-field v-else
                    :label="labelCpfResponsavel"
                    dense
                    placeholder="000.000.000-00"
                    :rules="rulesCpfResponsavel"
                    v-mask="'###.###.###-##'"
                    v-model.trim="value.cpf"/>
    </v-col>    
    <!-- ----------------------------------------------------  -->
    <v-col cols="12" md="4">
      <v-text-field label="* Celular"
                    dense
                    v-mask="'(##) #####-####'"
                    :rules="[
                      this.$validators.string.required,
                    ]"
                    v-model.trim="value.celular"/>
    </v-col>

    <v-col cols="12" md="4">
      <v-text-field label="Telefone"
                    dense
                    v-mask="'(##) ####-####'"
                    v-model.trim="value.telefone"/>
    </v-col> 
    <v-col cols="12" md="4">
      <v-text-field label="Data Nascimento"
                    dense
                    type="date"
                    v-model="value.dataNascimento" />
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  name: "ContatoForm",
  props: {
    value: {
      type: Object
    },
    empresaEstrangeira: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  },
  computed: {
    labelCpfResponsavel() {
      return this.empresaEstrangeira ? '* Registro do responsável' : '* CPF';
    },
    rulesCpfResponsavel() {
      const rules = [this.$validators.string.required];
      if (this.empresaEstrangeira) {
        rules.push(v => this.$validators.string.greaterThanOrEquals(v, 1));
        rules.push(v => this.$validators.string.lessThanOrEquals(v, 50));
      } else {
        rules.push(this.$validators.string.cpf);
      }
      return rules;
    },
  }
}
</script>

<style scoped>

</style>